import axiosInstance from '../axiosInstance';
import { URL } from '../config/constants';

/**
 * PTO / Bereavement API client.
 *
 * Balance + history are read FRESH from the server here (deliberately not from
 * IndexedDB) so a foreman always sees the latest standing — including grants
 * another foreman just made — which is what stops the same day being granted twice.
 */

export async function getPtoOverview(employeeId, year) {
    const params = new URLSearchParams();
    if (year) params.set('year', String(year));
    // Cache-buster: a unique URL makes the browser fetch fresh every time. We do
    // NOT add a Cache-Control request header — that's not CORS-safelisted and would
    // force a preflight the cross-origin API doesn't allow (localhost:3000 → admin host).
    params.set('_', String(Date.now()));
    const res = await axiosInstance.get(`${URL}/pto/overview/${employeeId}?${params.toString()}`);
    return res.data; // { employee, balance, history }
}

export async function createPtoRequest(payload) {
    const res = await axiosInstance.post(`${URL}/pto/requests`, payload);
    return res.data; // { ok, request, balance }
}

/** Stable, server-accepted (^[A-Za-z0-9_-]{1,64}$) idempotency id for one submission. */
export function newClientId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return `pto-${crypto.randomUUID()}`;
    }
    return `pto-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
